var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image-loader",class:{ loaded: _vm.loaded },attrs:{"alt":_vm.alt,"src":_vm.canLoad ? _vm.src : _vm.placeholderSrc,"height":_vm.height,"width":_vm.width},on:{"load":_vm.setLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }